// extracted by mini-css-extract-plugin
export default {"m":"Nav_m__DPUXy","money":"Nav_money__29GCt","add":"Nav_add__QiHa6"};